<script>
    import Stats from "./Stats.svelte";

    export let potions;
    export let onLoad;
    export let onRemove;
</script>

<div class="root">
    <span>Your potion shelf</span>
    {#if !potions.length}
        <span class="empty">Empty</span>
    {/if}
    {#each potions as potion, i}
        <div class="potion">
            <div class="buttons">
                <button on:click={onLoad(i)}>Load</button>
                <button on:click={onRemove(i)}>Remove</button>
            </div>
            <div class="name">{potion.name}</div>
            <div class="effects">
                {#each potion.effects as effect}
                    <div class="effect">
                        <img src={`/images/effects/${effect.replaceAll(" ", "_")}.jpg`} alt="glyph" />
                        <span class="effect-name">{effect}</span>
                    </div>
                {/each}
            </div>
            <Stats weight={potion.weight} value={potion.value} />
            <div class="ingredients">
                {#each potion.ingredients as ingredient}
                    <div class="ingredient">
                        <img src={`/images/ingredients/${ingredient.name.replaceAll(" ", "_")}.png`} alt="glyph" />
                        {#if ingredient.isTribunal}
                            <span class="expansion-mark">TR</span>
                        {/if}
                        {#if ingredient.isBloodmoon}
                            <span class="expansion-mark">BM</span>
                        {/if}
                        <span class="effect-name">{ingredient.name}</span>
                    </div>
                {/each}
            </div>
        </div>
    {/each}
</div>

<style>
    .root {
        width: 100%;
        height: 100%;

        display: flex;
        flex-direction: column;

        /* border-left: 1px solid #D8C187; */

        padding: 8px;

        overflow: auto;
    }
    .root > * {
        margin-bottom: 16px;
    }
    .potion {
        display: flex;
        flex-direction: column;
    }
    .effects {
        display: flex;
        flex-direction: column;
    }
    .buttons > button {
        height: 28px;
        font-size: 14px;
    }
    .buttons {
        margin-bottom: 4px;
    }

    .effect {
        display: flex;
        align-items: center;

        line-height: 32px;
        border-radius: 4px;
    }
    .effect-name {
        margin-left: 8px;
        margin-top: 4px;
    }

    .ingredient {
        display: flex;
        align-items: center;
    }

    .empty {
        color: rgb(168, 150, 134);
        align-self: center;
    }

    .expansion-mark {
        font-size: 8px;
        margin-left: -11px;
        line-height: 8px;
        margin-bottom: 23px;
    }
</style>